import { AxiosResponse } from "axios";
import client from "../client";
import { getOrderConfig } from "./GetOrderConfig";
import { getOrderResponse } from "./types";

const getOrder = ({
  applicationId,
}: {
  applicationId: string;
}): Promise<AxiosResponse<getOrderResponse>> => client({ ...getOrderConfig(applicationId) });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getOrder,
};
